import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SelectingEventArgs } from '@syncfusion/ej2-angular-navigations';
import { Dialog } from '@syncfusion/ej2-angular-popups';
import { ToastService } from 'src/app/libs/toast/toast.service';
import { PacienteService } from 'src/app/servicos/paciente.service';
import { PessoaDoencaService } from 'src/app/servicos/pessoa-doenca.service';
import { PacienteAgenteListaComponent } from '../paciente-agente-lista/paciente-agente-lista.component';
import { PacienteDoencaListaComponent } from '../paciente-doenca-lista/paciente-doenca-lista.component';
import { PacienteHistoriaListaComponent } from '../paciente-historia-lista/paciente-historia-lista.component';
import { PacienteLotacaoListaComponent } from '../paciente-lotacao-lista/paciente-lotacao-lista.component';
import { PacientePeriodicidadeListaComponent } from '../paciente-periodicidade-lista/paciente-periodicidade-lista.component';

interface PacienteForm {
  id: FormControl<number>;
  nome: FormControl<string>;
  cpf: FormControl<string>;
  pis: FormControl<string | null>;
  rg: FormControl<string>;
  idade: FormControl<number>;
  dataNascimento: FormControl<Date>;
  sexo: FormControl<string>;
}

@Component({
  selector: 'app-paciente-detalhe',
  templateUrl: './paciente-detalhe.component.html',
  styleUrls: ['./paciente-detalhe.component.less']
})
export class PacienteDetalheComponent implements OnInit {

  @ViewChild("modal")
  modal!: Dialog;

  @ViewChild("doencaLista")
  doencaLista!: PacienteDoencaListaComponent;

  @ViewChild("agenteLista")
  agenteLista!: PacienteAgenteListaComponent;

  @ViewChild("lotacaoLista")
  lotacaoLista!: PacienteLotacaoListaComponent;

  @ViewChild("periodicidadeLista")
  periodicidadeLista!: PacientePeriodicidadeListaComponent;

  @ViewChild("historiaLista")
  historiaLista!: PacienteHistoriaListaComponent;
  
  tabOk: boolean = false;

  lotacaoSelecaoAtualId: number = -1;

  modelo: FormGroup<PacienteForm> = this.fb.group<PacienteForm>({
    id: this.fb.nonNullable.control<number>(0),
    nome: this.fb.nonNullable.control<string>(''),
    cpf: this.fb.nonNullable.control<string>(''),
    pis: this.fb.control<string | null>(''),
    idade: this.fb.nonNullable.control<number>(0),
    rg: this.fb.nonNullable.control<string>(''),
    dataNascimento: this.fb.nonNullable.control<Date>(new Date()),
    sexo: this.fb.nonNullable.control<string>(''),
  });

  constructor(
    private fb: FormBuilder,
    private toast: ToastService, private paciente: PacienteService,
    private doencaService: PessoaDoencaService) { }

  ngOnInit(): void {
    this.paciente.pacienteAtual$
    .subscribe((dto) => {
      if(!dto)
        return;

      this.modelo.controls.id.setValue(dto.id);
      this.modelo.controls.nome.setValue(dto.nome);
      this.modelo.controls.cpf.setValue(dto.cpf);
      this.modelo.controls.dataNascimento.setValue(dto.dataNascimento);
      this.modelo.controls.pis.setValue(dto.pis);
      this.modelo.controls.rg.setValue(dto.rg);
      this.modelo.controls.sexo.setValue(dto.sexo);
      this.modelo.controls.idade.setValue(dto.idade);

      this.lotacaoSelecaoAtualId = dto.lotacaoAtribuicao?.sId ?? -1;
    });
  }

  mudandoTab(args: SelectingEventArgs) {
    if(args.selectingIndex === 1) {
      this.doencaLista.carregar();
      return;
    }

    if(args.selectingIndex === 2) {
      this.periodicidadeLista.carregar();
      return;
    }

    if(args.selectingIndex === 3) {
      this.lotacaoLista.carregar();
      return;
    }

    if(args.selectingIndex === 4) {
      this.agenteLista.carregar(this.lotacaoSelecaoAtualId);
      return;
    }

    if(args.selectingIndex === 5) {
      this.historiaLista.carregar();
      return;
    }    
  }

  abrir() {
    this.modal.show(true);
  }
}
